import { gql } from '@apollo/client'

export const PRICING_ERROR_FRAGMENT = gql`
  fragment PricingError on PricingError {
    __typename
    id
    upc
    expectedPrice
    observedPrice
    expectedUnitPrice
    observedUnitPrice
    createdAt
  }
`
